// extracted by mini-css-extract-plugin
export var closeButton = "_1e-1";
export var container = "_1e-0";
export var fullModalImage = "_1e-2";